"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _queryString = _interopRequireDefault(require("query-string"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useHelperApp = helpers => {
  const history = (0, _reactRouterDom.useHistory)();
  const location = (0, _reactRouterDom.useLocation)();
  const [helperObject, setHelperObject] = (0, _react.useState)({});
  const [helperToggleFunctions, setHelperToggleFunctions] = (0, _react.useState)({});
  const query = _queryString.default.parse(location.search);
  const [currentHelper, setCurrentHelper] = (0, _react.useState)(query?.helper);
  const handleToggleHelper = (0, _react.useCallback)(helper => {
    setCurrentHelper(helper !== currentHelper ? helper : undefined);
  }, [currentHelper]);
  const isOpen = hlp => {
    return currentHelper === hlp;
  };
  (0, _react.useEffect)(() => {
    if (!(0, _isEqual.default)(Object.keys(helperObject), Object.keys(helpers))) {
      setHelperObject(helpers);
    }
    const newHelperToggleFunctions = {};
    Object.keys(helperObject).forEach(h => {
      newHelperToggleFunctions[h] = () => handleToggleHelper(h);
    });
    if (!(0, _isEqual.default)(Object.keys(helperToggleFunctions), Object.keys(newHelperToggleFunctions))) {
      // This makes sure adding/removing helpers changes the functions
      setHelperToggleFunctions(newHelperToggleFunctions);
    }
    if (currentHelper !== query?.helper) {
      const newQuery = {
        ...query,
        helper: currentHelper
      };
      history.push({
        pathname: location.pathname,
        search: `?${_queryString.default.stringify(newQuery)}`
      });

      // When helper changes, reset helperToggleFunctions
      setHelperToggleFunctions(newHelperToggleFunctions);
    }
  }, [currentHelper, handleToggleHelper, helperObject, helperToggleFunctions, helpers, history, location, query]);

  // Set the HelperComponent
  const HelperComponent = (0, _react.useCallback)(props => {
    if (!query?.helper) return null;
    let Component = null;
    Component = helperObject[query?.helper];
    if (!Component) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
      onToggle: () => handleToggleHelper(query?.helper),
      ...props
    });
  }, [handleToggleHelper, helperObject, query?.helper]);
  return {
    currentHelper,
    HelperComponent,
    helperToggleFunctions,
    isOpen
  };
};
var _default = exports.default = useHelperApp;